
<template lang="pug">
  div
    .step-content
      div(style="")
        slot
        el-form(ref='form' :rules="(shippingMethod == 1) ? rules1 : rules2" label-position="top" :model='form')
          // el-form-item(label='工號' prop="id" required)
            el-input(v-model='form.id' disabled)
          el-form-item(label='1.寄件人手機：' prop="userTel")
            el-input(v-model='form.userTel' type="tel" maxlength="10" placeholder="0912345678" :disabled="true")
          el-form-item(label='2.寄件人姓名：' prop="userName")
            el-input(v-model='form.userName' placeholder="王大明")
          // el-form-item(label='E-Mail' prop="mail")
            el-input(v-model='form.mail' type="email" placeholder="XXXX@gamil.com")

          div(v-if="shippingMethod === 1") 
            el-form-item(label='3.收件地址：' prop="recipient_address" )
              el-input(v-model='form.recipient_address' placeholder="台北市XX區XXX路X段X號" @change="recipient_address_change")
                // div()
                //   el-radio(:label="1" v-model="form.recipient_address") 常用地址1：<br/><br/>地址：台北市內湖區XX路XX段XX號X樓 
                // div()
                //   el-radio(:label="2" v-model="form.recipient_address") 常用地址2：<br/><br/>地址：新北市中和區
                // div()
                  el-radio(:label="0" v-model="form.recipient_address") 其他地址<br/><br/>
            el-form-item(label='4.還件地址：' prop="return_address" )
                  // div()
                  //   el-radio(:label="1" v-model="form.return_address") 常用地址1：<br/><br/>地址：台北市內湖區XX路XX段XX號X樓 
                  // div()
                  //   el-radio(:label="2" v-model="form.return_address") 常用地址2：<br/><br/>地址：新北市中和區
                  div()
                    // el-radio(:label="0" v-model="form.return_address") 其他地址<br/><br/>
                    el-input(v-model='form.return_address' placeholder="台北市XX區XXX路X段X號")
            el-form-item(label='5.希望收件時間 (實際收件時間以約定為主)：' prop="recipient_date" style="display: inline-block;padding-right: 60px;")
              div(v-if="is_mobile")
                // lable 開始：
                input(type="date" v-model="form.recipient_date" style="width: 220px;" @change="handleRecipientDateChange")
              // div(v-if="is_compute")
                lable 開始：
                date-pick(
                class="datetime_input"
                  v-model="form.recipient_sdate"
                  :pickTime="true"
                  :format="'YYYY-MM-DD HH:mm'"
                )
              el-date-picker(
                v-model="form.recipient_date"
                type="date"
                class="datetime_input"
                placeholder="日期"
                :picker-options="recipient_pickerOptions_s"
                @change="handleRecipientDateChange"
                @closed="blur"
                v-if="is_compute") 
            div
              el-select.short(v-model="form.recipient_stime" placeholder="0:00")
                el-option(
                  key="10"
                  label="10:00"
                  value="10:00'" selected)
                el-option(
                  v-for="n in 13"
                  :key="(n+10)"
                  :label="(n+10)+':00'"
                  :value="(n+10)+':00'" :selected="n==13" v-show="!(s_is_sat && n >6)")
              span  ~ 
              el-select.short(v-model="form.recipient_etime" placeholder="23:00" )
                el-option(
                  key="10"
                  label="10:00"
                  value="10:00'")
                el-option(
                  v-for="n in 13"
                  :key="(n+10)"
                  :label="(n+10)+':00'"
                  :value="(n+10)+':00'" :selected="n==13" v-show="!(s_is_sat && n >6)")
            el-form-item(label='' prop="recipient_stime" )
            el-form-item(label='' prop="recipient_etime" )    
            
            el-form-item(label='6.希望還件時間 (實際還件時間會視作業進度約定)：' prop="return_date" style="display: inline-block;padding-right: 60px;")
              div(v-show="is_mobile")
                // lable 開始：
                input( type="date"
                v-model="form.return_date" style="width: 220px;"
                @change="handleReturnDateChange")
              el-date-picker(
                v-model="form.return_date"
                type="date"
                class="datetime_input"
                placeholder="日期"
                :picker-options="recipient_pickerOptions_e"
                @closed="blur"
                @change="handleReturnDateChange"
                v-show="is_compute") 
            div
              el-select.short(v-model="form.return_stime" placeholder="0:00")
                el-option(
                  key="10"
                  label="10:00"
                  value="10:00'")
                el-option(
                  v-for="n in 13"
                  :key="(n+10)"
                  :label="(n+10)+':00'"
                  :value="(n+10)+':00'" :selected="n==13" v-show="!(e_is_sat && n >6)")
              span  ~ 
              el-select.short(v-model="form.return_etime" placeholder="23:00" )
                el-option(
                  key="10"
                  label="10:00"
                  value="10:00'")
                el-option(
                  v-for="n in 13"
                  :key="(n+10)"
                  :label="(n+10)+':00'"
                  :value="(n+10)+':00'" :selected="n==13" v-show="!(e_is_sat && n >6)")

            div(style="color: red; padding-top: 10px") *服務員收件後，送洗需耗時約2個工作天(急件另加收費用）
            
            el-form-item(label='希望付款方式：' prop="payment" v-show="show_from_payment")
              el-select(v-model="form.payment" @change="onPaymentChange")
                el-option(
                  key="1"
                  label="1. 現金"
                  value="1"
                  :disabled="payment1_disabled")
                el-option(
                  key="2"
                  label="2. 匯款"
                  value="2")
                el-option(
                  key="3"
                  label="3. 預繳"
                  value="3")
                el-option(
                  key="4"
                  label="4. 月結"
                  value="4")
                el-option(
                  key="5"
                  label="5. 刷卡"
                  value="5")
                el-option(
                  key="6"
                  label="6. LinePay"
                  value="6")

            el-form-item(label='7.送洗袋數：' prop="bags_number")
              el-select(v-model="form.bags_number")
                el-option(
                  key="1"
                  label="1"
                  value="1")
                el-option(
                  key="2"
                  label="2"
                  value="2")
                el-option(
                  key="3"
                  label="3"
                  value="3")
                el-option(
                  key="4"
                  label="4"
                  value="4")
            center
              img(src="@/assets/size.png" class="col2-img")
            el-form-item(label='8.服務項目 ：(如果您不確定,請選基本洗衣服務即可,客服會在Line@中與您討論)' prop="service_items")
              el-checkbox-group(v-model="form.service_items")
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="1" key="1") 1.基本洗衣服務 原價NT$480 (含基本水洗+高溫烘乾+折疊)
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="2" key="2") 2.大型床組 (3大條) NT$550 (清洗 床罩組, 被單, 保潔墊, 涼被)(未鋪棉)
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="3" key="3") 3.清洗冬天棉被/毛毯一床 NT$550 (請確認您的棉被可以水洗)
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="4" key="4") 4.窗簾組清洗-- 另外報價 (窗簾因為材質厚薄差異很大, 且不能烘乾, 所以會在收件後另外報價)
            
            span(style="font-size: 14px;color: red;") 如果您有未下水過的新衣服或毛巾, 請告知我們並勾選分色清洗, 以免造成衣物染色
            el-form-item(label='9.額外加購項目（每袋）：' prop="purchase_item")
              el-checkbox-group(v-model="form.purchase_item")
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="1" key="1") 1.額外加購分色/分槽清洗 NT$150 (分二槽水洗+分二槽高溫烘乾)
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="2" key="2") 2.額外加購低溫烘乾 NT$150 (全程使用低溫烘乾)
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="3" key="3" :disabled="form.service_items.indexOf('1') === -1") 3.額外襯衫刷洗每件加價 NT$20
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="4" key="4" :disabled="form.service_items.indexOf('1') === -1") 4.清洗羽絨外套每件加價 NT$50
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="5" key="5" :disabled="form.service_items.indexOf('2') === -1 && form.service_items.indexOf('3') === -1") 5.鋪棉床單/鋪棉被單/鋪棉保潔墊/鋪棉四季被/薄毛毯/床裙 每件加價NT$50 (需搭配 550 元床組袋)
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="6" key="6" :disabled="form.service_items.indexOf('1') === -1") 6.風乾晾曬每件 NT$20
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="7" key="7") 7.特殊髒污清洗費用每件 NT$150
                <!--其實急件費用是service_items的5, 送到後端前會改-->
                div
                  el-checkbox(style="width: 100%;margin-left: 0;display: inline-flex;" label="8" key="8") 8.急件費用 NT$300
            div 如果有乾洗部分送件後會跟您個別報價，不必於預約時選購
            el-form-item(label='10.補充說明：(如: 請至一樓管理員取件)' prop="other")
              el-input(
                type="textarea"
                rows="4"
                placeholder="文字訊息"
                v-model="form.other")


    .cart__footer(class="new-footer")
      el-col(:span="12")
        el-button.white-button(type="success" style="float:left;" @click="goBack") 上一步
      el-col(:span="12")
        el-button.black-button(type="primary" style="float:right;" @click="submit") 下一步
    el-dialog(
      width="80%"
      title="月結/預繳"
      :visible.sync="paymentInfo"
      append-to-body)
      center 如您想成為月結/預繳會員，請洽詢Line@官方帳號。專員會儘速與您聯繫說明。
</template>
<script>
// 驗證
const phoneValidator = (rule, value, callback) => {
  // mail驗證方式 https://ithelp.ithome.com.tw/articles/10094951
  const phoneRule = /^[09]{2}[0-9]{8}$/
  console.log(value)
  if (value.length === 0) {
    callback(new Error('請輸入手機號碼'))
  } else if (value.search(phoneRule) === -1) {
    callback(new Error('請輸入正確手機格式'))
  } else {
    callback()
  }
}

import Cookies from 'js-cookie'
import { getUserInfo } from '@/api/user'
import { couponList, getHoliday } from '@/api/index'

import DatePick from 'vue-date-pick';
import moment from 'moment'

export default {
  name: 'CartDetail',
  props: {
    details: {
      type: Object
    },
    shippingMethod: {
      type: Number,
      required: true
    }
  },
  components: {
    DatePick
  },
  data () {
    return {
      s_is_sat: false,
      e_is_sat: false,
      getHoliday: {},
      is_mobile: false,
      is_compute: false,
      coupon_id: '',
      show_coupon: false,
      // payment
      show_from_payment: true,
      preferred_payment: "",
      paymentInfo: false,
      payment1_disabled: false,
      form: {
        id: '',
        userName: '',
        userTel: Cookies.get('phone'),
        mail: '',
        address: '',
        pay: '1',
        grids_number: 1,
        bags_number: 1,
        payment: "1",
        recipient_address: '',
        return_address: '',
        recipient_date: new Date(new Date().getTime() + 3600 * 1000 * 24 * 1).toISOString().slice(0,10) ,
        recipient_sdate: null,
        recipient_edate: null,
        // recipient_time: [],
        return_date: new Date(new Date().getTime() + 3600 * 1000 * 24 * 3).toISOString().slice(0,10),
        return_sdate: null,
        return_edate: null,
        // return_time: [],
        service_items: [],
        purchase_item: [],
        other: null,
        edcode: null,
        recipient_stime: "10:00",
        recipient_etime: "16:00",
        return_stime: "10:00",
        return_etime: "16:00",
      },
      rules1: {
        userName: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        // userTel: [{ required: true, message: '請輸入手機號碼', trigger: 'blur' }],
        // mail: [{ required: true, validator: mailValidator, trigger: 'blur' }],
        userTel: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
        recipient_address: [{ required: true, message: '請輸入收件地址', trigger: 'blur' }],
        return_address: [{ required: true, message: '請輸入還件地址', trigger: 'blur' }],
        recipient_date: [{ required: true, message: '請輸入收件開始日期', trigger: 'blur' }],
        // recipient_edate: [{ required: true, message: '請輸入收件結束日期', trigger: 'blur' }],
        return_date: [{ required: true, message: '請選擇還件開始日期', trigger: 'blur' }],
        // return_edate: [{ required: true, message: '請選擇還件結束日期', trigger: 'blur' }],
        service_items: [{ required: true, message: '請選擇服務項目', trigger: 'blur' }],
        
        recipient_stime: [{ required: true, message: '請選擇收件時間', trigger: 'blur' }],
        recipient_etime: [{ required: true, message: '請選擇收件時間', trigger: 'blur' }],
        return_stime: [{ required: true, message: '請選擇還件時間', trigger: 'blur' }],
        return_etime: [{ required: true, message: '請選擇還件時間', trigger: 'blur' }],
        
        // pay: [{ required: true, message: '請選擇付款方式', trigger: 'blur' }]
      },
      rules2: {
        userName: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        // userTel: [{ required: true, message: '請輸入手機號碼', trigger: 'blur' }],
        userTel: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
        // mail: [{ required: true, validator: mailValidator, trigger: 'blur' }],
        recipient_address: [{ required: true, message: '請輸入收件地址', trigger: 'blur' }],
        service_items: [{ required: true, message: '請選擇服務項目', trigger: 'blur' }],
        // pay: [{ required: true, message: '請選擇付款方式', trigger: 'blur' }]
      },

      // recipient_pickerOptions: {
      //     disabledData: (time)=>{
      //       // if(this.form.return_date){
      //       //   return time.getTime() > this.form.return_date;
      //       // }else{
      //         return time.getTime() <= Date.now();
      //       // }
      //   }
      // },
      recipient_pickerOptions_s: {
         disabledDate: (time) => {
            // // 取得假日
            // for(let i = 0; i < this.getHoliday; i++) {
            //   let {date} = this.getHoliday[i]
            //   if(time.getTime() == date ){
            //     return true
            //   }
            // }
           // 週日不營業
           let is_sunday = new Date(time).getDay() === 0
           if(this.form.recipient_edate){
              return time.getTime() <= Date.now() - 3600 * 1000 * 24 * 1 ||  time.getTime() > this.form.recipient_edate || is_sunday  || this.getHoliday[time.getTime()];
            }else{
              return time.getTime() <= Date.now() - 3600 * 1000 * 24 * 1 || new Date(time).getDay() === 0 || is_sunday || this.getHoliday[time.getTime()];
            }
            //  return time.getTime() > new Date(2017, 11, 30) || time.getTime() < new Date(2017, 11, 11);//注意是||不是&&
         }
     },
      recipient_pickerOptions_e: {
         disabledDate: (time) => {
           // 週日不營業
           let is_sunday = new Date(time).getDay() === 0
           if(this.form.recipient_sdate){
              return time.getTime() < Date.now() - 3600 * 1000 * 24 * 1 ||  time.getTime() < this.form.recipient_sdate || is_sunday || this.getHoliday[time.getTime()];
            }else{
              return time.getTime() < Date.now() - 3600 * 1000 * 24 * 1 || is_sunday || this.getHoliday[time.getTime()];
            }
            //  return time.getTime() > new Date(2017, 11, 30) || time.getTime() < new Date(2017, 11, 11);//注意是||不是&&
         }
     },
    //   return_pickerOptions_s: {
    //      disabledDate: (time) => {
    //         let recipient_sdate_boolean = false
    //         if(this.form.recipient_sdate){
    //           recipient_sdate_boolean = time.getTime() < this.form.recipient_sdate
    //         }

    //         if(this.form.return_edate){
    //           return time.getTime() < Date.now() - 3600 * 1000 * 24 * 1 || time.getTime() > this.form.return_edate || recipient_sdate_boolean ;
    //         }else{
    //           return time.getTime() < Date.now() - 3600 * 1000 * 24 * 1 || recipient_sdate_boolean ;
    //         }
    //         //  return time.getTime() > new Date(2017, 11, 30) || time.getTime() < new Date(2017, 11, 11);//注意是||不是&&
    //      }
    //  },
    //   return_pickerOptions_e: {
    //      disabledDate: (time) => {

    //         let recipient_sdate_boolean = false
    //         if(this.form.recipient_edate){
    //           recipient_sdate_boolean = time.getTime() < this.form.recipient_sdate
    //         }

    //        if(this.form.return_sdate){
    //             return time.getTime() <= Date.now() - 3600 * 1000 * 24 * 1 || time.getTime() < this.form.return_sdate || recipient_sdate_boolean ;
    //           }else{
    //             return time.getTime() <= Date.now() - 3600 * 1000 * 24 * 1 || recipient_sdate_boolean;
    //           }
    //         //  return time.getTime() > new Date(2017, 11, 30) || time.getTime() < new Date(2017, 11, 11);//注意是||不是&&
    //      }
    //  },
      
    }
  },
  beforeCreate(){
  },
  created() {
    if (this._isMobile()) {
      // alert("手機")
      this.is_mobile = true
      this.is_compute = false
    } else {
      // alert("電腦")
      this.is_mobile = false
      this.is_compute = true
    }

    getHoliday({}).then(res=>{
      res.data.data.forEach(v=>{
        let {date} = v
        let ts = Date.parse(date+ "T00:00:00.000+08:00")
        this.getHoliday[ts] = true;
      })
      
    })
  },
  methods: {
    // payment
    onPaymentChange() {
      let v = this.form.payment
      console.log("v", v)
      console.log("this.preferred_payment", this.preferred_payment)
      if((this.preferred_payment != 4 && this.preferred_payment != 3) && (v == 3 || v == 4)){
        this.paymentInfo = true
        this.form.payment= "1"
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    blur() {
      document.querySelector(":focus").blur();
    },
    recipient_address_change(){
      console.log("a")
      this.form.return_address = this.form.recipient_address
    },
    recipientPicker(time){
      if(this.form.return_date){
        return time.getTime() > this.form.return_date;
      }else{
        return time.getTime() <= Date.now();
      }
    },
    returnPicker(time){
      if(this.form.recipient_date){
        return time.getTime() <= this.form.recipient_date + 3600 * 1000 * 24 * 3;
      }else{
        return time.getTime() <= Date.now();
      }
    },
      // recipient_pickerOptions() {
      //   return {
      //     disabledDate(time) {
      //     // if(form.return_date){
      //     //   return time.getTime() > form.return_date;
      //     // }else{
      //       return time.getTime() <= Date.now();
      //     // }

      //   }
      //   }
        
      // },
      // return_pickerOptions() {
      //   return {
      //     disabledDate(time) {
      //       if(form.recipient_date){
      //         return time.getTime() <= form.recipient_date + 3600 * 1000 * 24 * 3;
      //       }else{
      //         return time.getTime() <= Date.now();
      //       }
            
      //     }
      //   }
        
      // },
    goBack () {
      this.$emit('setStep', -1)
      this.$router.go(-1)
    },
    submit () {

      //驗證
      // 日期驗證
      if(this.form.return_date && this.form.recipient_date  && (moment(this.form.return_date).format('d') === '0' || moment(this.form.recipient_date).format('d') === '0')){
        let date;
        if(moment(this.form.return_date).format('d') === '0'){
          date = this.form.return_date;
        }
        if(moment(this.form.recipient_date).format('d') === '0')
        {
          date = this.form.recipient_date;
        }
        alert(`週日不收送喔～ 請修改收${date}(週日)的日期`)
        return
      }

      // 驗證後台設定的假日
      let return_date = moment(this.form.return_date, "YYYY-MM-DD").unix() + "000";
      let recipient_date = moment(this.form.recipient_date, "YYYY-MM-DD").unix() + "000";
      if(this.getHoliday[return_date] || this.getHoliday[recipient_date]){
        let date = this.getHoliday[return_date] ? this.form.return_date : this.form.recipient_date;
        alert(`「${date}」易立洗公休不收送喔～ 請修改日期後再重新送出`)
        return
      }

      // 若為急件，則不檢查工作天
      if(this.form.purchase_item.indexOf("8") == -1){
        // 驗證距離兩天以上
        if(moment(this.form.recipient_date, "YYYY-MM-DD").add(1, 'days') >=  moment(this.form.return_date, "YYYY-MM-DD") ){
          alert("收件後依您衣物狀況會幫您評估並您約定還件時間, 基本工作天數為兩天, 請挑選兩個工作天後的還件日期")
          alert("您也可以選擇急件，服務人員會再和您約時間")
          return
        }

        // 1~7
        if(moment(this.form.recipient_date, "YYYY-MM-DD").isoWeekday() == 5 || moment(this.form.recipient_date, "YYYY-MM-DD").isoWeekday() == 6 || moment(this.form.recipient_date, "YYYY-MM-DD").isoWeekday() == 7) {
          if(moment(this.form.return_date, "YYYY-MM-DD").isoWeekday() == 1){
            alert("收件後依您衣物狀況會幫您評估並您約定還件時間, 基本工作天(不含假日)數為兩天, 請挑選兩個工作天後的還件日期")
            alert("您也可以選擇急件，服務人員會再和您約時間")
            return
          }
        }
      }

      // 驗證週六晚上16點後不收還件
      const recipientDate = new Date(this.form.recipient_date);
      if(recipientDate.getDay() === 6 && this.form.recipient_etime.substring(0, 2) > 16){
       alert("週六 16點後不收送喔～ ")
      }
      const returnDate = new Date(this.form.return_date);
      if(returnDate.getDay() === 6 && this.form.return_etime.substring(0, 2) > 16){
       alert("週六 16點後不收送喔～ ")
      }

      // 一般預約驗證
      this.$refs['form'].validate(valid => {
        if (!valid) {
          setTimeout(()=>{
            // var isError= document.getElementsByClassName("is-error");
            // isError[0].querySelector('input').focus();
            // $('.is-error').get(0).focus();
            var city_top = $('.is-error').offset().top;
            console.log(city_top)
                $('html,body').animate({scrollTop:city_top},500);
            
          },200);
          return false
        }
        let recipient_date = moment(new Date(this.form.recipient_date)).format("YYYY-MM-DD")
        let return_date = moment(new Date(this.form.return_date)).format("YYYY-MM-DD")
        console.log(this.form)
        this.form.recipient_sdate = recipient_date+ " " + this.form.recipient_stime
        this.form.recipient_edate = recipient_date + " " + this.form.recipient_etime 
        this.form.return_sdate = return_date + " " + this.form.return_stime
        this.form.return_edate = return_date + " " + this.form.return_etime
        console.log(this.form)
        this.$emit('keyInDetail', this.form)
        this.$emit('setStep', 1)
        this.$router.push({ name: 'check' })
      })
    



      
      
    },
    handleReturnDateChange() {
      const returnDate = new Date(this.form.return_date);
      if(returnDate.getDay() === 0){
        alert("週日不收送喔～ ")
        newReturnDate.setDate(returnDate.getDate() + 2);
        this.form.return_date = newReturnDate.toISOString().substr(0, 10);
      }

      if(returnDate.getDay() === 6 && this.form.return_etime.substring(0, 2) > 16){
       this.form.return_stime = "15:00"
       this.form.return_etime = "16:00"
      }

      this.e_is_sat = new Date(this.form.return_date).getDay() === 6
    },
    handleRecipientDateChange() {
      const recipientDate = new Date(this.form.recipient_date);
      if(recipientDate.getDay() === 0){
        alert("週日不收送喔～ ")
        newRecipientDate.setDate(recipientDate.getDate() + 2);
        this.form.return_date = newRecipientDate.toISOString().substr(0, 10);
      }
      if(recipientDate.getDay() === 6 && this.form.recipient_etime.substring(0, 2) > 16){
       this.form.recipient_stime = "15:00"
       this.form.recipient_etime = "16:00"
      }
      this.s_is_sat = recipientDate.getDay() === 6;
      this.checkReturnDate();
    },
    checkReturnDate() {
      const recipientDate = new Date(this.form.recipient_date);
      const returnDate = new Date(this.form.return_date);

      if (returnDate < recipientDate) {
        const newReturnDate = new Date(recipientDate);
        newReturnDate.setDate(recipientDate.getDate() + 3);

        // 如果收件日期是周日，则还件日期再加一天
        console.log("newReturnDate.getDay() ", newReturnDate.getDay())
        if (newReturnDate.getDay() === 0) {
          newReturnDate.setDate(newReturnDate.getDate() + 2);
        }
        this.form.return_date = newReturnDate.toISOString().substr(0, 10);
      }
    },
  },
  mounted () {
    document
      .querySelectorAll(".datetime_input input")
      .forEach(e => (e.readOnly = true));
    console.log(this.shippingMethod)
    // if(!this.shippingMethod){
    //   this.$router.replace({ name: 'info' })
    // }
    this.form.id = this.$store.state.employeeID
    if(this.details){
      console.log("有資料", this.details)
      this.form = this.details;
    }
    this.form.userTel = Cookies.get('phone');
    console.log("this.form.userTel", this.form.userTel)
    if(!this.form.userName || !this.form.recipient_address || !this.form.return_address ){
      console.log("無個人資料，需要問api")
      getUserInfo({userTel: this.form.userTel}).then(res=>{
        console.log(res)
        this.form.userName = res.data.userName
        this.form.recipient_address = res.data.address
        this.form.return_address = res.data.address

        // payment 判斷
        let payment = ""
        if(res.data.preferred_payment != null){
          payment = res.data.preferred_payment.toString()
        }
        this.preferred_payment = payment
        // 越節 不顯示
        if(payment == 4){
          this.show_from_payment = false
        }
        // 非雙北
        let no_taipai_user = res.data.address.indexOf('新北') === -1 && res.data.address.indexOf('台北') === -1 && res.data.address.indexOf('臺北') === -1
      
        // 非雙北，不能現金
        if(no_taipai_user){
          this.payment1_disabled = true
        }

        // 預設值
        this.form.payment = payment
        if(res.data.order_count == 0){
          if(no_taipai_user){
            this.form.payment = "2"
          }else{
            this.form.payment = "1"
          }
        }
        console.log("res.data.service_items", res.data.service_items)
        console.log("res.data.purchase_item", res.data.purchase_item)
        // 判斷是否帶入上次的服務選項
        if(res.data.service_items != ""){
          res.data.service_items.split(",").forEach(v=>{
            this.form.service_items.push(v)
          })
        }
        if(res.data.purchase_item != ""){
          res.data.purchase_item.split(",").forEach(v=>{
            this.form.purchase_item.push(v)
          })
        }

        // SI5急件 在前端改成PI8
        let urgentIndex = this.form.service_items.indexOf("5")
        if(urgentIndex != -1){
          if(this.form.purchase_item.indexOf("8")){
            this.form.purchase_item.push("8") // 加入急件
          }
          this.form.service_items.splice(urgentIndex, 1); // 刪除急件
        }
      })
    }

    // 查詢優惠
    couponList({userTel: this.form.userTel}).then(res=>{
      console.log(res.data)
      if(res.data.length > 0){
        this.coupon_id = res.data[0]['coupon_id']
        this.show_coupon = true
      }else{
        this.show_coupon = false
      }
    })
  }
}
</script>
<style >
.el-checkbox__label {
  	display: inline-flex;white-space: pre-line;word-wrap: break-word;overflow: hidden;line-height: 20px;
}

</style>
 <style lang="scss" scoped >
.cart {
  &__footer {
    // background: white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    // position: fixed;
    bottom: 0;
    border-top: 1px solid #ccc;
    z-index: 99;
    height: 60px;
    width: 100vw;
    margin-left: -20px;
    margin-bottom: -20px;
    padding: 0 20px;
    .el-button {
      width: 30vw;
    }
  }
}

img.col2-img {
  width: 80%;
  padding: 5px;
}


@media (min-width: 800px) {

 img {
    width: 45%;
    padding: 5px;
  }
  // .cart__footer {
  //   width: 75vw;
  // }
  .el-input__inner {
    width: 40%;
  }
 img.col2-img {
    width: 45%;
    padding: 5px;
  }
}

// @media (min-width: 1000px) {

//  img {
//     width: 35%;
//     padding: 5px;
//   }
//   .cart__footer(class="new-footer") {
//     width: 50vw;
//   }
//   .el-input__inner {
//     width: 30%;
//   }
//  img.col2-img {
//     width: 35%;
//     padding: 5px;
//   }
//   .cart__footer(class="new-footer") {
//     width: 50vw;
//   }
//   .cart__footer(class="new-footer") .el-button {
//     width:25vw;
//   }
// }

</style>
